import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { bool, string, number, object } from "prop-types";
import { WithLazy } from "@quintype/components";
import Dailymotion from "react-dailymotion";
import YouTube from "react-youtube";

import VideosLogo from "../../atoms/icons/videos-logo";
import { getDmVideo } from "../../helper/api";
import translate from "../../translate";

import "./also-watch.m.css";

const DmPlayer = ({ playListId }) => {
  const [videoId, setVideoId] = useState();

  useEffect(() => {
    getDmVideo(playListId)
      .then((res) => res.json())
      .then((playList) => setVideoId(get(playList, ["list", "0", "id"], null)));
  }, []);

  return (
    <div styleName="player">{videoId && <Dailymotion video={videoId} autoplay autoplayQueue showQueue mute />}</div>
  );
};

DmPlayer.propTypes = {
  playListId: string,
};

const YoutubePlayer = ({ playListId }) => {
  const options = {
    playerVars: {
      autoplay: 1,
      mute: 1,
      listType: "playlist",
      list: playListId,
    },
  };

  const onReady = (e) => {
    e.target.playVideo();
  };

  return (
    <div styleName="player">
      <YouTube opts={options} onReady={onReady} />;
    </div>
  );
};

YoutubePlayer.propTypes = {
  playListId: string,
};

const AlsoWatch = ({ enabled, hideInMobile, index, publisherName, type, alsoWatch }) => {
  if (!enabled || (index !== 0 && global.width < 768 && hideInMobile)) return null;

  const Player = type === "youtube" ? YoutubePlayer : DmPlayer;
  const playListId = alsoWatch[type].playlist_id;

  return (
    <WithLazy margin="300px">
      {() => (
        <div styleName="wrapper">
          <div styleName="video-icon">
            <VideosLogo />
            <div styleName="title">{translate(publisherName, "also_watch")}</div>
          </div>
          <Player playListId={playListId} />
        </div>
      )}
    </WithLazy>
  );
};

AlsoWatch.propTypes = {
  enabled: bool,
  hideInMobile: bool,
  type: string,
  alsoWatch: object,
  index: number,
  publisherName: string,
};

const mapStateToProps = (state) => {
  const hideInMobile = get(state, ["qt", "config", "publisher-attributes", "hide_in_mobile", "also_watch"], false);
  const publisherAttributes = get(state, ["qt", "config", "publisher-attributes"]);
  const item = publisherAttributes.also_watch;

  return {
    enabled: item.enabled,
    type: item.type,
    alsoWatch: item,
    publisherName: publisherAttributes.name,
    hideInMobile,
  };
};

export default connect(mapStateToProps, null)(AlsoWatch);
